import { Box, ToggleButton, ToggleButtonGroup, Typography, useTheme, Skeleton } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
import { onSnapshot, collection, query, orderBy } from "firebase/firestore";
import { db } from "../../utils/firebase/firebase";
import { TABLES_FIREBASE } from "../../utils/firebase/firebase.typestables";
import AdminTable from "../../components/admin-table";
import AdminPersonalizedDashboard from "../../components/admin-table/AdminPersonalizedDashboard.jsx";

const AdminPage = () => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const [transactions, setTransactions] = useState([]);
	const [loadingData, setLoadingData] = useState(true);
	const [viewMode, setViewMode] = useState("sales");

	useEffect(() => {
		const collRef = collection(db, TABLES_FIREBASE.transactions);
		const q = query(collRef, orderBy("createdAt", "desc"));

		const unsubscribe = onSnapshot(q, (snapshot) => {
			const transactionsData = snapshot.docs.map((doc) => ({
				...doc.data(),
				id: doc.id,
			}));

			const formatTransactions = transactionsData
				.filter((data) => data.status !== "cancelado")
				.map((data, index) => {
					const paymentCheck = data.pagamento ? data.pagamento : " - ";
					const dateFormat = new Date(data.createdAt.seconds * 1000);

					const formattedDate = dateFormat.toLocaleString("pt-BR", {
						day: "2-digit",
						month: "2-digit",
						year: "numeric",
						hour: "2-digit",
						minute: "2-digit",
					});

					return {
						...data,
						pagamento: paymentCheck,
						dataCreated: formattedDate,
						count: index + 1,
					};
				});

			setTransactions(formatTransactions);
			setLoadingData(false);
		});

		return () => unsubscribe();
	}, []);

	// Helper para renderizar o esqueleto da tabela
	const TableSkeleton = () => (
		<Box width="100%" mt={2}>
			<Skeleton variant="rectangular" height={40} sx={{ borderRadius: "8px", mb: 1, bgcolor: colors.primary[400] }} />
			{[...Array(5)].map((_, i) => (
				<Skeleton key={i} variant="text" height={60} sx={{ mb: 0.5, opacity: 0.5 }} />
			))}
		</Box>
	);

	return (
		<Box
			display="flex"
			flexDirection="column"
			sx={{
				width: "100%",
				height: "100%",
				marginTop: "70px",
				px: 2,
			}}
		>
			<Box
				width="100%"
				display="flex"
				justifyContent="flex-end"
				alignItems={{ xs: "flex-start", md: "center" }}
				flexDirection={{ xs: "column", md: "row" }}
				gap={2}
				mb={4}
			>

				<ToggleButtonGroup
					exclusive
					value={viewMode}
					onChange={(_, value) => {
						if (value) setViewMode(value);
					}}
					sx={{
						background: colors.primary[400],
						justifySelf: 'flex-end',
						p: "5px",
						borderRadius: "12px",
						border: `1px solid ${colors.primary[500]}`,
						"& .MuiToggleButton-root": {
							px: 3,
							py: 1,
							textTransform: "none",
							fontWeight: 700,
							border: "none",
							borderRadius: "8px",
							color: colors.grey[200],
							"&.Mui-selected": {
								backgroundColor: colors.greenAccent[600],
								color: "white",
								"&:hover": {
									backgroundColor: colors.greenAccent[700],
								},
							},
						},
					}}
				>
					<ToggleButton value="sales">Vendas</ToggleButton>
					<ToggleButton value="personalized">Personalizados</ToggleButton>
				</ToggleButtonGroup>
			</Box>

			{/* Lógica de Renderização Original com Skeleton no lugar do CircularProgress */}
			{viewMode === "sales" ? (
				<>
					{loadingData && <TableSkeleton />}

					{transactions && !loadingData && (
						<AdminTable transactions={transactions} />
					)}
				</>
			) : (
				<AdminPersonalizedDashboard />
			)}
		</Box>
	);
};

export default AdminPage;